const phoneNumberRegex = /[^0-9 ()+-]/g;

export default phoneNumberRegex;
